import { Navigate, Outlet, useLocation } from "react-router-dom";

import useAuth from "../hooks/useAuth";

const RequireAuth = ({ redirectUrl }) => {
  const { auth } = useAuth();
  const { location } = useLocation();

  if (!auth?.accessToken) {
    return (
      <Navigate
        replace
        state={{ state: { from: location } }}
        to={redirectUrl}
      />
    );
  }

  return <Outlet />;
};

export default RequireAuth;
